import { BannerChip } from './BannerChips.types'

export const bannerChips: BannerChip[] = [
  {
    label: 'NFL',
    href: '/nfl-travel-packages',
  },
  {
    label: 'Super Bowl',
    href: '/package/tickets/BS-935036',
  },
  {
    label: 'NCAAF',
    href: 'https://bookseats.com/college-football-travel-packages',
  },
]
